import PublicPropertiesCollection from '@netx/core-app/collections/publicProperties';
import {usePublicPropertiesStore} from '@netx/core-app-next/store/publicProperties';

export const publicProperties = new PublicPropertiesCollection();

// we will import the store for now and keep it up to date
// this eliminates the need for the the store to import this _singleton_ file
// which brings along A LOT of baggage
publicProperties
    .on('sync add remove change reset', () => {
        usePublicPropertiesStore.setState({publicProperties: publicProperties.models.map(m => ({...m.attributes}))});
    });
